import TaskService from '@/services/task.service'
import Utils from '@/utils'
import _ from 'lodash'

const state = {
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    totalTasks: {
        total: {
            demand: 0,
            solicitation: 0
        },
        today: {
            demand: 0,
            solicitation: 0
        },
        yesterday: {
            demand: 0,
            solicitation: 0
        },
        'two-or-more-days-before': {
            demand: 0,
            solicitation: 0
        }
    },
    filterLoading: false
}

const getters = {}

const actions = {
    readTasks: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (state.page.index == args.page) return true
        try {
            commit('reading')
            const page = await TaskService.readTasks(args)
            commit('readTasksSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readTotalTasks: async ({ commit }) => {
        try {
            const totalTasks = await TaskService.readTotalTasks()
            commit('readTotalTasksSuccess', totalTasks)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    reading(state) {
        state.filterLoading = true
    },

    readTasksSuccess(state, page, page_index) {
        state.page = page
        state.page.index = page_index
        state.filterLoading = false
    },

    readTotalTasksSuccess(state, totalTasks) {
        state.totalTasks = totalTasks
    }
}

const tasks = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default tasks
export { tasks }
